import React from 'react';

const JPMorganWealthAdvisorDisclaimer = () => (
  <div className="disclaimer">
    <p>
      Investing involves market risk, including possible loss of principal, and
      there is no guarantee that investment objectives will be achieved. You are
      being referred to the J.P. Morgan Wealth Management website,{' '}
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.chase.com/personal/investments/advisor-contact-form/personal-advisors"
      >
        https://www.chase.com/personal/investments/advisor-contact-form/personal-advisors
      </a>
      , where investment products and services are provided by J.P. Morgan
      Securities LLC (&ldquo;J.P. Morgan&ldquo;), a registered broker dealer and
      investment adviser, member FINRA and SIPC, by NerdWallet, a third-party
      publisher of J.P. Morgan, (&ldquo;Publisher&ldquo;). The Publisher that is
      directing you to this webpage will receive compensation from J.P. Morgan
      if you provide contact details to speak with a J.P. Morgan representative.
      Compensation paid to the Publisher will be up to $500 per completed
      contact form. Compensation provides an incentive for the Publisher to
      endorse J.P. Morgan and therefore information, opinions, or referrals are
      subject to bias. J.P. Morgan and the Publisher are not under common
      ownership or otherwise related entities, and each are responsible for
      their own obligations. By clicking on the button on this page, you are
      acknowledging receipt of the foregoing disclosure.
    </p>
    <p style={{ marginTop: '15px' }}>
      INVESTMENT AND INSURANCE PRODUCTS ARE: NOT A DEPOSIT • NOT FDIC INSURED •
      NO BANK GUARANTEE • MAY LOSE VALUE.
    </p>
  </div>
);

JPMorganWealthAdvisorDisclaimer.propTypes = {};
JPMorganWealthAdvisorDisclaimer.displayName = 'JPMorganWealthAdvisorDisclaimer';

export default JPMorganWealthAdvisorDisclaimer;
